







import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { FixedLoading } from "../../system";
import { FixedPhraseRootReference } from "../../../domain/document";
import FixedPhraseTreeSelector from "../fixedPhrase/FixedPhraseTreeSelector.vue";
import { FixedPhraseTreeSelectorMixin } from "../fixedPhrase/mixins";
import { IEditFixedPhrase } from "../fixedPhrase/IEditFixedPhrase";
import { FixedPhraseKinds } from "../fixedPhrase/FixedPhraseKinds";
import { AiFixedPhraseSelectorMixin } from "./mixins";
import { AiSyntaxDialog } from "./dialogs";

@Component({
  components: {
    FixedLoading,
    selector: FixedPhraseTreeSelector,
    AiSyntaxDialog,
  }
})
export default class AiDepartmentFixedPhraseSelector extends Mixins(
  AiFixedPhraseSelectorMixin,
  FixedPhraseTreeSelectorMixin,
) implements IEditFixedPhrase {
  @Prop()
  departmentId: string;

  @Prop({ default: true })
  isPastable: boolean;

  async created(): Promise<void> {
    await this.loadRootFixedPhrase();
  }

  mounted(): void {
    this.selector = this.$refs.selector;
  }

  @Emit("doubleClicked")
  doubleClicked(): void {}

  @Emit("dragStart")
  dragStart(event: DragEvent, text: string): void {}

  async editFixedPhrase(): Promise<void> {
    if (!this.isLoaded) {
      return;
    }
    return this.executeWithManagementTokenControll("定型文", isForcibly => this.getManagementToken(FixedPhraseKinds.AiDepartment, isForcibly, this.departmentId), this.executeEditFixedPhrase);
  }

  private async executeEditFixedPhrase(): Promise<void> {
    const latest = await this.getFixedPhrase(FixedPhraseKinds.AiDepartment, this.departmentId);
    const result = await this.getEditedFixedPhrase(latest, FixedPhraseKinds.AiDepartment, this.departmentId, this.aiFixedPhraseOptions);
    if (result == null) { return; }
    await this.setFixedPhrase(FixedPhraseKinds.AiDepartment, result);
  }

  private async loadRootFixedPhrase(): Promise<void> {
    if (this.departmentId === null) {
      this.rootFixedPhrase = new FixedPhraseRootReference(null, null, []);
      return;
    }
    try {
      this.rootFixedPhrase = await this.getFixedPhrase(FixedPhraseKinds.AiDepartment, this.departmentId);
    } catch (e) {
      this.rootFixedPhrase = new FixedPhraseRootReference(null, null, []);
      this.$error(
        "主" + this.$wording.common.departmentAsShort + "生成AI定型文取得失敗",
        "主" + this.$wording.common.departmentAsShort + "生成AI定型文を読み込めませんでした。",
        e);
    }
  }
}
